export default __webpack_public_path__ + "static/media/ico-flipchart.6d98e428.svg";